import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SensorsUtils from '../utils/SensorsUtils';
import CropRenameModal from './CropRenameModal';

const MyCropCard = ({ crop }) => {
    const navigate = useNavigate();
    const [name, setName] = useState(crop.name);
    const [showRename, setShowRename] = useState(false);

    const handleClick = () => {
        navigate(`/my-crops/${crop.id}`);
    };

    const bgImage = SensorsUtils.getBackgroundSensor(crop.cropType?.name) || '/assets/images/backgrounds/default.jpg';

    return (
        <div
            onClick={handleClick}
            className="w-full max-w-sm bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden cursor-pointer border border-gray-100"
        >
            {/* Image & Overlay */}
            <div className="h-48 relative">
                <img
                    src={bgImage}
                    alt={name}
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex flex-col justify-end p-4">
                    <h3 className="text-white text-2xl font-bold">{name}</h3>
                    <p className="text-gray-200 text-sm">{crop.location}</p>
                </div>
            </div>

            {/* Content - Simplified as per user request */}
            <div className="p-5">
                <div className="flex justify-between items-center mb-4">
                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${crop.active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                        {crop.active ? 'ACTIVO' : 'INACTIVO'}
                    </span>
                    <div className="flex items-center text-gray-500 text-xs font-medium">
                        <span className="material-icons-outlined text-base mr-1">sensors</span>
                        Sensores: {crop.sensorsCount !== undefined ? crop.sensorsCount : (crop.sensors?.length || 0)}
                    </div>
                </div>

                <div className="pt-3 border-t border-gray-100 flex justify-between items-center">
                    {/* El vendedor solo ve los cultivos de sus clientes (alquiler o compra): sin lápiz */}
                    {crop.editable !== false ? (
                        <button type="button" title="Cambiar nombre" onClick={(event) => {
                            event.stopPropagation(); // Evita que el clic abra el seguimiento del cultivo
                            setShowRename(true);
                        }} className="text-blue-600 hover:text-green-600 transition duration-200">
                            <span className="material-icons-outlined">edit</span>
                        </button>
                    ) : <span />}
                    <button className="text-green-600 font-medium text-sm hover:text-green-700 flex items-center">
                        Administrar Ciclos
                        <span className="material-icons-outlined text-sm ml-1">arrow_forward</span>
                    </button>
                </div>
            </div>

            {showRename && (
                <div onClick={(e) => e.stopPropagation()}> {/* Evita que los clics del modal abran el cultivo */}
                    <CropRenameModal crop={{ ...crop, name }} onClose={() => setShowRename(false)} onRenamed={setName} />
                </div>
            )}
        </div>
    );
};

export default MyCropCard;
